import {environments} from './configs';
import {LANGUAGE_CODES} from '@guestapp/core';

const IS_SDK_MODE = environments.VITE_APP_IS_SDK;

class ChekinProSettings {
  static get settings() {
    return window.ChekinProSettings || {};
  }

  static get isSDK() {
    return IS_SDK_MODE ?? false;
  }

  static get autoHeight() {
    return ChekinProSettings.settings.autoHeight ?? false;
  }

  static get apiKey() {
    return ChekinProSettings.settings.apiKey ?? '';
  }

  static get reservationId() {
    return ChekinProSettings.settings.reservationId;
  }

  static get housingId() {
    return ChekinProSettings.settings.housingId;
  }

  static get externalHousingId() {
    return ChekinProSettings.settings.externalHousingId;
  }

  static get guestId() {
    return ChekinProSettings.settings.guestId;
  }

  static get externalReservationId() {
    return ChekinProSettings.settings.externalId;
  }

  static get defaultLanguage() {
    if (IS_SDK_MODE) {
      return (
        ChekinProSettings.settings.defaultLanguage ||
        environments.VITE_APP_DEFAULT_LANGUAGE ||
        LANGUAGE_CODES.en
      );
    }

    return undefined;
  }

  static get styles() {
    return ChekinProSettings.settings.styles;
  }

  static get prefillData() {
    return ChekinProSettings.settings.prefillData;
  }

  static get stylesLink() {
    return ChekinProSettings.settings.stylesLink;
  }

  static get externalId() {
    return ChekinProSettings.settings.externalId;
  }

  static get mode() {
    return ChekinProSettings.settings.mode;
  }

  static get canShareRegistrationLink() {
    if (IS_SDK_MODE) {
      return ChekinProSettings.settings.canShareRegistrationLink;
    }
    return true;
  }

  static get canEditReservationDetails() {
    if (IS_SDK_MODE) {
      return ChekinProSettings.settings.canEditReservationDetails;
    }
    return true;
  }

  static get isMobileModalModeAvailable() {
    if (IS_SDK_MODE) {
      return !ChekinProSettings.settings.autoHeight;
    }
    return true;
  }
}

export default ChekinProSettings;
